import { CountUp } from "countup.js";

export function blockStats() {
    document.querySelectorAll('.stats-block').forEach((block) => {
        block.querySelectorAll('.number').forEach((number) => {

            let end_number = number.dataset.number,
                has_decimals = (number.dataset.number % 1 !== 0) ? 1 : 0,
                start_number = (end_number > 100) ?  (end_number * 0.8) : 0,
                suffix = number.dataset.suffix;

            let numb = new CountUp(number, end_number, {
                startVal : start_number,
                suffix: suffix,
                duration: 1.5,
                scrollSpyDelay: 400,
                enableScrollSpy: true,
                scrollSpyOnce: true,
                useEasing: true,
                decimalPlaces: has_decimals,
            })
            if(!numb.error) {
                numb.start()
            }else{
                console.log(numb.error)
            }

        })
    })
}